'use strict';
/* eslint-disable camelcase, no-undef */
__webpack_public_path__ = (window.kraken && window.kraken.config.publicPath) || '/';
/* eslint-enable camelcase, no-undef */
